import NetworkHandler from 'utils/network';
import config from 'config';

// Bảng kê chi tiết thu tiền
function getCollectSales(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}`, {
        ...params,
    });
}
function saveCollectSales(body) {
    return NetworkHandler.post(`${config.getUrl('collect_sales')}`, {
        ...body,
    });
}

function historyCollectSales(id, params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/history/${id}`, {
        params,
    });
}
function getCollectSalesDepositRefer(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/deposit-refer`, {
        ...params,
    });
}
// Bảng kê tổng hợp thu tiền
function getSummaryConductor(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/summary-conductor`, {
        ...params,
    });
}

function getSummaryChecker(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/summary-checker`, {
        ...params,
    });
}

function getDepositOrder(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/checker/deposit-order`, {
        ...params,
    });
}

function saveCheckerDeposit(body) {
    return NetworkHandler.post(`${config.getUrl('collect_sales')}/checker/deposit`, {
        ...body,
    });
}

function depositOrderConfirm(id, body) {
    return NetworkHandler.post(`${config.getUrl('collect_sales')}/checker/deposit-order/confirm/${id}`, {
        ...body,
    });
}

// Thu ngân nộp ngân hàng
function cashierDepositOrder(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/cashier/deposit-order`, {
        ...params,
    });
}

function saveCashierDeposit(body) {
    return NetworkHandler.post(`${config.getUrl('collect_sales')}/cashier/deposit`, {
        ...body,
    });
}

function deleteCashierDeposit(id) {
    return NetworkHandler.delete(`${config.getUrl('collect_sales')}/cashier/deposit/${id}`);
}
//
function getOrderStatisticMoney(params) {
    return NetworkHandler.get(`${config.getUrl('collect_sales')}/accountant/order-statistic-money`, {
        ...params,
    });
}
export default {
    getCollectSales,
    saveCollectSales,
    historyCollectSales,
    getSummaryConductor,
    getSummaryChecker,
    getCollectSalesDepositRefer,
    getDepositOrder,
    saveCheckerDeposit,
    depositOrderConfirm,
    cashierDepositOrder,
    saveCashierDeposit,
    deleteCashierDeposit,
    getOrderStatisticMoney,
};
